var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05546 4.05546C2.57118 3.53973 3.27065 3.25 4 3.25H11C11.4142 3.25 11.75 3.58579 11.75 4C11.75 4.41421 11.4142 4.75 11 4.75H4C3.66848 4.75 3.35054 4.8817 3.11612 5.11612C2.8817 5.35054 2.75 5.66848 2.75 6V20C2.75 20.3315 2.8817 20.6495 3.11612 20.8839C3.35054 21.1183 3.66848 21.25 4 21.25H18C18.3315 21.25 18.6495 21.1183 18.8839 20.8839C19.1183 20.6495 19.25 20.3315 19.25 20V13C19.25 12.5858 19.5858 12.25 20 12.25C20.4142 12.25 20.75 12.5858 20.75 13V20C20.75 20.7293 20.4603 21.4288 19.9445 21.9445C19.4288 22.4603 18.7293 22.75 18 22.75H4C3.27065 22.75 2.57118 22.4603 2.05546 21.9445C1.53973 21.4288 1.25 20.7293 1.25 20V6C1.25 5.27065 1.53973 4.57118 2.05546 4.05546Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2.62866C19.6363 2.62866 19.2875 2.77314 19.0303 3.03031L9.67724 12.3834L9.03079 14.9692L11.6166 14.3228L20.9697 4.96965C21.2269 4.71248 21.3713 4.36368 21.3713 3.99998C21.3713 3.63629 21.2269 3.28749 20.9697 3.03031C20.7125 2.77314 20.3637 2.62866 20 2.62866ZM17.9697 1.96965C18.5082 1.43118 19.2385 1.12866 20 1.12866C20.7615 1.12866 21.4919 1.43118 22.0303 1.96965C22.5688 2.50813 22.8713 3.23846 22.8713 3.99998C22.8713 4.7615 22.5688 5.49184 22.0303 6.03031L12.5303 15.5303C12.4342 15.6264 12.3138 15.6946 12.1819 15.7276L8.18192 16.7276C7.92634 16.7915 7.65597 16.7166 7.46969 16.5303C7.2834 16.344 7.20851 16.0737 7.27241 15.8181L8.27241 11.8181C8.30538 11.6862 8.37357 11.5658 8.46969 11.4697L17.9697 1.96965Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.915ce10b08029e8dcf7581eddc2468ce.svg";
export { ForwardRef as ReactComponent };